import React, { ReactNode } from 'react';

import { NcAlertBanner } from '../NcAlertBanner';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/page-with-alert-banner.scss';

export const NcPageWithAlertBanner: React.FC<{ children: ReactNode; }> = ({ children }) => {
  return (
    <div className="nc-page-with-alert-banner">
      <NcAlertBanner />

      {children}
    </div>
  );
};
